import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'chemicals_hazardous_substances'

export const dataPointDefinition = {
  retracedId: 'chemicals_hazardous_substances',
  name: 'Chemicals/Hazardous substances',
  description:
    'Chemicals/Hazardous substances refers to safety measures and practices in place regarding hazardous chemicals and substances used within the facility. ',
  meta: {
    slcpMeta: {
      key: 'ms-1--12-6x',
      number: 'MS-PLA-14-6',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ms-1--12-6x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 32140,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
